import { getGraphQLErrors } from 'lib/helpers/getGraphQLErrors/getGraphQLErrors'

interface IsApolloErrorWithCodeOptions {
  code: string
}

export const isApolloErrorWithCode = (error: unknown, { code }: IsApolloErrorWithCodeOptions): boolean =>
  getGraphQLErrors(error).some(({ extensions }) => extensions?.code === code)
